import httpRequest from "services/httpRequest";

const _prefix = "/api/broadcast-list";

export const onCreateBroadcastList = async params => {
  const result = await httpRequest({
    url: `${_prefix}`,
    method: "POST",
    data: params,
    successMessage: "toast.create_success",
  });
  return result;
};

export const onGetBroadcastListPage = async params => {
  const result = await httpRequest({
    url: `${_prefix}`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onGetBroadcastListCustomerPage = async params => {
  const result = await httpRequest({
    url: `${_prefix}/broadcast-lists-customer`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onGetBroadcastListDetail = async params => {
  const result = await httpRequest({
    url: `${_prefix}/${params}`,
    method: "GET",
  });
  return result;
};

export const onUpdateBroadcastList = async params => {
  const result = await httpRequest({
    url: `${_prefix}/${params.id}`,
    method: "PUT",
    data: params.data,
    successMessage: "toast.update_success",
  });
  return result;
};

export const onDeleteBroadcastList = async params => {
  const result = await httpRequest({
    url: `${_prefix}/${params}`,
    method: "DELETE",
    successMessage: "toast.delete_success",
  });
  return result;
};

export const onGetAllBroadcastList = async () => {
  const result = await httpRequest({
    url: `${_prefix}/all`,
    method: "GET",
  });
  return result;
};

export const onGetBroadcastListNotIn = async params => {
  const result = await httpRequest({
    url: `${_prefix}/all-not-in`,
    method: "GET",
    params: params,
  });
  return result;
};

export const onAddCustomerNotInBroadcastList = async params => {
  const result = await httpRequest({
    url: `${_prefix}/not-in`,
    method: "POST",
    data: params,
  });
  return result;
};
